import React, { useEffect } from 'react';

const TAWKTO_PROPERTY_ID = 'YOUR_PROPERTY_ID'; // Replace with your Tawk.to property ID
const TAWKTO_WIDGET_ID = 'YOUR_WIDGET_ID'; // Replace with your Tawk.to widget ID

const LiveChatWidget = () => {
  useEffect(() => {
    if (window.Tawk_API) return; // Prevent multiple script loads
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://embed.tawk.to/${TAWKTO_PROPERTY_ID}/${TAWKTO_WIDGET_ID}`;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return null;
};

export default LiveChatWidget; 